import { render, staticRenderFns } from "./CommerceInbound.vue?vue&type=template&id=4323b47a&"
import script from "./CommerceInbound.vue?vue&type=script&lang=ts&"
export * from "./CommerceInbound.vue?vue&type=script&lang=ts&"
import style0 from "./CommerceInbound.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports